 import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axiosInstance, { weburl } from "../../../axiosInstance";
 import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LoadingScreen from "../../components/LoadingScreen";
import { triggerChooseimg } from "../../components/ChooseImg";
import Gallery from "../../components/Gallery";
import getDecryptData from "../../../helper/getDecryptData";
import { useBlogContext } from "../../../fetchdata/BlogContext";


const AccountCreate = () => {


    const {
      Headers,
  
    } = useBlogContext();


  const navigate = useNavigate();
  const [filteredCities, setFilteredCities] = useState([]);

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);


  const [dataNew, setDataNew] = useState([]);

      const [imageDivs, setImageDivs] = useState([]);
      const [imageGalleryDivs, setImageGalleryDivs] = useState([]);

  
      
    const addGalleryImageDiv = () => {
      const newImageDiv = (
        <div key={imageGalleryDivs.length} className={`col-md-3 col-6`}>
          <div className={`input-group imageupload-bx mb-3`}>
            <img
              className="image-preview"
              src="/assets/images/placeholder.png"
              alt="Preview"
              id={`imageGalleryinput${imageGalleryDivs.length}`}
              data-bs-toggle="modal"
              data-bs-target="#modal-default"
            />
            <input
              type="hidden"
              className="form-control imageopen"
              id={`imageGalleryproduct${imageGalleryDivs.length}`}
              name="productGalleryImg[]"
              value="assets/images/placeholder.png"
            />
          </div>
          <button
            className="btn btn-danger d-block m-auto"
            onClick={removeImageDiv}
          >
            Delete
          </button>
          <br />
        </div>
      );
  
      const updatedImageDivs = [...imageGalleryDivs, newImageDiv];
      setImageGalleryDivs(updatedImageDivs);
      setTimeout(function () {
        triggerChooseimg();
       }, 1);
    };
  
  const removeImageDiv = (event) => {
    const button = event.target;
    const parentDiv = button.parentNode; // Accessing the parent div
    parentDiv.remove(); // Remove the parent div
  };

    const addImageDiv = () => {
      const newImageDiv = (
        <div key={imageDivs.length} className={`col-md-3 col-6`}>
          <div className={`input-group imageupload-bx mb-3`}>
            <img
              className="image-preview"
              src="/assets/images/placeholder.png"
              alt="Preview"
              id={`imageinput${imageDivs.length}`}
              data-bs-toggle="modal"
              data-bs-target="#modal-default"
            />
            <input
              type="hidden"
              className="form-control imageopen"
              id={`imageproduct${imageDivs.length}`}
              name="productImg[]"
              value="assets/images/placeholder.png"
            />
          </div>
          <button
            className="btn btn-danger d-block m-auto"
            onClick={removeImageDiv}
          >
            Delete
          </button>
          <br />
        </div>
      );
  
      const updatedImageDivs = [...imageDivs, newImageDiv];
      setImageDivs(updatedImageDivs);
      setTimeout(function () {
        triggerChooseimg();
       }, 1);
    };
  
 


  const [inputs, setInputs] = useState({
    type: "",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    coverage: [], // this must be an array!
    department: [], // this must be an array!
    images:[],
    gallery:[],
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const CreateSlug = (str) => {
    var slug = str;

    // Convert to lowercase
    slug = slug.toLowerCase();

    // Replace spaces with hyphens
    slug = slug.replace(/\s+/g, "-");

    // Remove special characters (only allow alphanumeric, hyphens, and underscores)
    slug = slug.replace(/[^a-z0-9\-]/g, "");

    return slug;
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;

    // Handle multi-checkbox logic
    if (type === "checkbox") {
      if (name === "OfferEquipment") {
        // If 'specialization' is being updated, add/remove values from the array
        newValue = checked
          ? [...(inputs.OfferEquipment || []), value] // Add value if checked
          : (inputs.OfferEquipment || []).filter((item) => item !== value); // Remove value if unchecked
      } else if (name === "NatureOfBusiness") {
        // If 'specialization' is being updated, add/remove values from the array
        newValue = checked
          ? [...(inputs.NatureOfBusiness || []), value] // Add value if checked
          : (inputs.NatureOfBusiness || []).filter((item) => item !== value); // Remove value if unchecked
      } else {
        newValue = checked;
        console.log(type, name, newValue);
      }
    } else if (type === "file") {
      // Handle file input
      newValue = files[0];
    } else {
      // Handle normal text inputs
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        // setFilteredCities(selectedState?.pincodes?.areas ?? []);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
            city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }


if (name === "pincode") {
  const selectedState = data.find((state) => state._id === inputs.state);

  if (selectedState) {
    const pincodeData = (selectedState.pincodes || []).find(
      (pin) => pin.code === newValue
    );

    setFilteredCities(pincodeData?.areas ?? []);
    
    console.log("selectedState", selectedState, newValue, pincodeData);
  }
}




    if (name === "coverage") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.coverage) ? inputs.coverage : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          coverage: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
    if (name === "department") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.department) ? inputs.department : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          department: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
    // Capitalize the text for 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
      // Update the state with the new value
      setInputs((prevData) => ({
        ...prevData,
        profile_url: CreateSlug(newValue),
      }));
    }

    // Capitalize the text for 'username' field
    if (name === "profile_url") {
      newValue = CreateSlug(newValue);
    }

    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const removeCoverage = (cityToRemove) => {
    setInputs((prev) => ({
      ...prev,
      coverage: prev.coverage.filter((c) => c !== cityToRemove),
    }));
  };

  const removeDepartment = (departmentId) => {
    // Remove the department from the array
    setInputs({
      ...inputs,
      department: inputs.department.filter(id => id !== departmentId),
    });
  };
  

  const [showPassword, setShowPassword] = useState(false);

  const handleDescriptionChange = (value) => {
    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      about: value,
    }));
  };

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //form handle
  // const fetchUserById = async () => {
  //   const decryptdatajson = await getDecryptData();
  //   const id = decryptdatajson?._id;

  //   const credentials = {
  //     id: id,
  //   };

  //   try {
  //     const { data } = await axiosInstance.post("/auth-user", credentials);
  //     const { success, token, existingUser, message } = data;

  //     if (success) {
  //       setInputs((prevData) => ({
  //         ...prevData,
  //         username: existingUser.username || "",
  //         phone: existingUser.phone || "",
  //         email: existingUser.email || "",
  //         address: existingUser.address || "",
  //         pincode: existingUser.pincode || "",
  //         state: existingUser.state || "",
  //         statename: existingUser.statename || "",
  //         country: existingUser.country || "",
  //         city: existingUser.city || "",
  //         about: existingUser.about || "",
  //         department: existingUser.department || "",
  //         Doc1: existingUser.Doc1 || "",
  //         Doc2: existingUser.Doc2 || "",
  //         Doc3: existingUser.Doc3 || "",
  //         profile: existingUser.profile || "",
  //         aadharno: existingUser.aadharno || "",
  //         pHealthHistory: existingUser.pHealthHistory || "",
  //         cHealthStatus: existingUser.cHealthStatus || "",
  //         coverage: existingUser.coverage || [],
  //         gallery: existingUser.gallery || [],
  //         images: existingUser.images || [],
  //         call: existingUser.call || '',
  //         whatsapp: existingUser.whatsapp || '',
  //         establishment: existingUser.establishment || '',
  //       }));
  //     }

  //     console.log("success", existingUser);
  //   } catch (error) {
  //     console.error("Error during login:", error);
  //     // Handle network errors, API issues, etc.
  //     toast.error(error.response.data.message);
  //   }
  // };

  // useEffect(() => {
  //   fetchUserById();
  // }, []);

  const handleSubmit = async () => {
    if(!inputs.empType){
      toast.error('Seller type is required')
      return
    }
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson?._id;

    setSubmitLoading(false);
    console.log(inputs);
    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "Gender", message: "Please enter Gender" },
       { name: "state", message: "Please enter State" },
      { name: "pincode", message: "Please enter pincode" },
      { name: "address", message: "Please enter address" },
            { name: "establishment", message: "Please enter establishment" },

                  { name: "whatsapp", message: "Please enter whatsapp no" },

      { name: "profile", message: "Please choose profile photo" },
      // {
      //   name: "AadhaarFront",
      //   message: "Please choose Aadhaar Front photo ",
      // },
      // {
      //   name: "AadhaarBack",
      //   message: "Please choose Aadhaar Back photo ",
      // },
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(true);
        return;
      }
    }

        const imageGalleryInputs = document.querySelectorAll(
      '#imageContainerGallery input[type="hidden"]'
    );
    const inputGalleryValues = Array.from(imageGalleryInputs).map((input) => input.value);

            const imageInputs = document.querySelectorAll(
      '#imageContainer input[type="hidden"]'
    );
    const inputValues = Array.from(imageInputs).map((input) => input.value);

        const updatedFormData = {
      ...inputs, 
      gallery: inputGalleryValues, 
      images: inputValues, 

    };

    console.log("inputsinputs", inputs);
    try {
      const { data } = await axiosInstance.post(
        `/create-user-vendor/${id}`,
        updatedFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { success } = data;
      if (success) {

        toast.success("Account created Successfully. Waiting for approval from administrator");
       navigate("/");

      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones-category");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones || []);
      setData2(response.data.Categories || []);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };





  useEffect(() => {
    fetchData();
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>


      <div className="container">
        <div className="d-flex gap-4 justify-content-between p-4 align-items-center">
          {/* Logo */}
          <Link
            className="navbar-brand flex-shrink-0 flex-fill "
            to="/"
            style={{ borderRadius: 5, aspectRatio: "120/25", height: 40 }}
          >
            {Headers.meta_logo && Headers.meta_logo !== undefined ? (
              <img
                src={Headers.meta_logo}
                width={120}
                alt="logo"
                style={{
                  maxHeight: 50,
                  width: "auto",
                  filter: "grayscale(0)",
                  mixBlendMode: "multiply",
                }}
              />
            ) : (
              <div
                className="card-1 skeleton"
                style={{
                  borderRadius: 5,
                  aspectRatio: "142/25",
                  width: "100%",
                  height: 50,
                }}
              ></div>
            )}
          </Link>
          <Link className="btn btn-dark btn-md rounded-xl" to={'/'} >
            <i class="ri-arrow-left-circle-line text-white"></i> Back</Link>

        </div>
      </div>


      <main className="content bg-light">
       

        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="container pt-0">
              <div
                className="dashboard-content px-4 py-3 "
                style={{ maxWidth: "100vw" }}
              >
                <div className="col-md-6">
                  <label className="mb-4   h4">  Become Seller </label>
                </div>
                {loading ? <LoadingScreen /> :
                  <form className="m-b20 row">
                    <div className="card  border-0 bg-white p-4 mb-4">
                      <div className="row">

     <div className="col-md-8">
                  <label className="mb-2"> Select Seller Type </label>

                  <ul className="customradio input-group two-grid  mb-4 px-0 mx-0">
                    <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="1"
                        checked={inputs.empType === "1"}
                      />
                      <label>Farmer Seller</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="2"
                        checked={inputs.empType === "2"}
                      />
                      <label>Near Shop</label>
                    </li>
                    
                      <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="3"
                        checked={inputs.empType === "3"}
                      />
                      <label>Retailer Seller</label>
                    </li>
                      <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="4"
                        checked={inputs.empType === "4"}
                      />
                      <label>Wholeseller</label>
                    </li>

                      <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="5"
                        checked={inputs.empType === "5"}
                      />
                      <label>Company Seller</label>
                    </li>

                  </ul>
                </div>

                        <div className="mb-4">
                          <label className="form-label text-dark" htmlFor="name">
                            Full Name{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="text"
                              id="username"
                              className="form-control"
                              name="username"
                              value={inputs.username}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="email">
                            Email{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              
                              type="email"
                              id="email"
                              className="form-control"
                              name="email"
                              value={inputs.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="phone">
                            Phone{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                               
                              type="email"
                              id="phone"
                              className="form-control"
                              name="phone"
                              value={inputs.phone}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6 col-md-4 ">
                          <label
                            className="form-label text-dark"
                            htmlFor="Gender"
                          >
                            Gender{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              value={inputs.Gender}
                              name="Gender"
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                Select Gender
                              </option>
                              <option value="1">Male</option>
                              <option value="2">Female</option>
                              <option value="0">Other</option>
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6 col-md-4 ">
                          <label className="form-label text-dark" htmlFor="email">
                            State{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="state"
                              name="state"
                              value={inputs.state}
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                {loading ? "Loading..." : "Select State"}
                              </option>
                              {data.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>

                 


        <div className="mb-4 col-6 col-md-4">
                          <label className="form-label text-dark" htmlFor="establishment">
                          Year of establishment 
                            <span className="text-danger">(Required ) </span>
                          </label>
                          <div className="input-group   input-sm">
                            <input 
                              type="tel"
                              id="establishment"
                              className="form-control"
                              name="establishment"
                              value={inputs.establishment}
                              onChange={handleChange}
                              maxLength={4}
                            />
                          </div>
                        </div>


                        <div className="mb-4 col-6 col-md-4">
                          <label className="form-label text-dark" htmlFor="phone">
                          Secondary Phone No.  
                            <span className="text-danger">(Show on profile) </span>
                          </label>
                          <div className="input-group   input-sm">
                            <input 
                              type="number"
                              id="call"
                              className="form-control"
                              name="call"
                              value={inputs.call}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                         <div className="mb-4 col-6 col-md-4">
                          <label className="form-label text-dark" htmlFor="phone">
                           Whatsapp No.
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                               
                              type="number"
                              id="whatsapp"
                              className="form-control"
                              name="whatsapp"
                              value={inputs.whatsapp}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
 
 <hr/>

         <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="Pincode">
                            Pincode
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <input
                              type="number"

                              id="pincode"
                              className="form-control custom-date"
                              name="pincode"
                              value={inputs.pincode}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

       <div className="mb-4 col-6 col-md-4">
                          <label className="form-label text-dark" htmlFor="city">
                            Area{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="city"
                              name="city"
                              value={inputs.city}
                              onChange={handleChange}
                            >
                              <option selected value={""} disabled>
                                {" "}
                                {!inputs.city ? "Select City" : inputs.city}
                              </option>
                              {filteredCities.map((city, index) => (
                                <option key={index} value={city}>
                                  {city}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>


   {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Coverage Areas <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="coverage"
            name="coverage"
         onChange={handleChange}
         selected={inputs.coverage}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Coverage Area
            </option>
            {filteredCities.map((city, index) => (
              <option key={index} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.coverage) && inputs.coverage.length > 0 ? (
    inputs.coverage.map((city, index) => (
      <span
        key={index}
        className="badge bg-primary me-1"
        style={{ cursor: "pointer" }}
        onClick={() => removeCoverage(city)}
        title="Click to remove"
      >
        {city} ×
      </span>
    ))
  ) : (
    <span className="text-muted">No coverage cities selected.</span>
  )}
</div>



               
                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="password"
                              value={inputs.password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Confirm Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="confirm_password"
                              value={inputs.confirm_password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>



                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            Department{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="department"
                              name="department"
                              value={'null'}
                              onChange={handleChange}
                            >
                              <option >
                                 Select departments
                              </option>
                              {data2.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.title}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>

                          <div className="mb-4">
  {Array.isArray(inputs.department) && inputs.department.length > 0 ? (
    inputs.department.map((departmentId, index) => {
      const department = data2.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeDepartment(departmentId)}
          title="Click to remove"
        >
          {department.title} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No coverage cities selected.</span>
  )}
</div>


                        </div>


                        <div className="mb-4 col-12  ">
                          <label className="form-label text-dark" htmlFor="email">
                            Address
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <textarea
                              id="pincode"
                              className="form-control custom-date"
                              name="address"
                              value={inputs.address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                      

                         <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="profileImage">
                                                  Profile Image
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                        {inputs.profile && typeof inputs.profile === "string" ? (
                          <img
                            src={inputs.profile !== "" ? weburl + inputs.profile : "/img/profile-default.png"}
                            id="ProfileImage"
                            alt="Profile Image"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: "",
                              objectFit: "cover",
                              border: "1px solid grey",
                            }}
                          />
                        ) : (
                          <img
                            src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" 
                              ? weburl + inputs.profile 
                              : "/img/profile-default.png"}
                            id="ProfileImage"
                            alt="Profile Image"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: "",
                              objectFit: "cover",
                              border: "1px solid grey",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          id="profileImage"
                          className="form-control"
                          name="profileImage"
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = (e) => {
                                const imgElement = document.getElementById("ProfileImage");
                                if (imgElement) {
                                  imgElement.src = e.target.result; // Set the image URL directly on the img element
                                }
                              };
                              reader.readAsDataURL(file); // Read the file as a data URL
                              setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
                            }
                          }}
                        />
                      </div>
                      
                                              </div>
                      
                      
                      
                                              <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="Doc1">
                                                  Document 1
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                        {inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1.indexOf(".pdf") !== -1 ? (
                          <embed
                            src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
                            id="LicensingImage"
                            alt="Document 1"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: 5,
                              objectFit: "contain",
                              border: "1px solid grey",
                            }}
                          />
                        ) : (
                          <img
                            src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
                            id="LicensingImage"
                            alt="Document 1"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: 5,
                              objectFit: "contain",
                              border: "1px solid grey",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          id="Doc1"
                          className="form-control"
                          name="Doc1"
                          accept=".jpg, .jpeg, .png, .pdf, .webp"
                          onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = (e) => {
                                const imgElement = document.getElementById("LicensingImage");
                                if (imgElement) {
                                  var computedStyle = window.getComputedStyle(imgElement);
                                  var allStyles = "";
                                  for (var i = 0; i < computedStyle.length; i++) {
                                    var styleProperty = computedStyle[i];
                                    allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                  }
                      
                                  var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                  iframe.src = e.target.result;
                                  iframe.style.cssText = allStyles;
                                  iframe.style.border = "none";
                                  iframe.id = imgElement.id;
                                  imgElement.parentNode.replaceChild(iframe, imgElement);
                                }
                              };
                              reader.readAsDataURL(file);
                              setInputs((prevData) => ({ ...prevData, Doc1: file }));
                            }
                          }}
                        />
                      </div>
                      
                      
                                              </div>
                      
                                              {/* Duplicate for Doc2 */}
                                              <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="Doc2">
                                                  Document 2
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                                                  {inputs.Doc2 && typeof inputs.Doc2 === "string" && inputs.Doc2.indexOf(".pdf") !== -1 ? (
                                                    <embed
                                                      src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                                      id="LicensingImage2"
                                                      alt="Document 2"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                                      id="LicensingImage2"
                                                      alt="Document 2"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  )}
                                                  <input
                                                    type="file"
                                                    id="Doc2"
                                                    className="form-control"
                                                    name="Doc2"
                                                    accept=".jpg, .jpeg, .png, .pdf, .webp"
                                                    onChange={(event) => {
                                                      const file = event.target.files[0];
                                                      if (file) {
                                                        const reader = new FileReader();
                                                        reader.onload = (e) => {
                                                          const imgElement = document.getElementById("LicensingImage2");
                                                          if (imgElement) {
                                                            var computedStyle = window.getComputedStyle(imgElement);
                                                            var allStyles = "";
                                                            for (var i = 0; i < computedStyle.length; i++) {
                                                              var styleProperty = computedStyle[i];
                                                              allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                                            }
                      
                                                            var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                                            iframe.src = e.target.result;
                                                            iframe.style.cssText = allStyles;
                                                            iframe.style.border = "none";
                                                            iframe.id = imgElement.id;
                                                            imgElement.parentNode.replaceChild(iframe, imgElement);
                                                          }
                                                        };
                                                        reader.readAsDataURL(file);
                                                        setInputs((prevData) => ({ ...prevData, Doc2: file }));
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </div>
                      
                                              {/* Duplicate for Doc3 */}
                                              <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="Doc3">
                                                  Document 3
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                                                  {inputs.Doc3 && typeof inputs.Doc3 === "string" && inputs.Doc3.indexOf(".pdf") !== -1 ? (
                                                    <embed
                                                      src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                                      id="LicensingImage3"
                                                      alt="Document 3"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                                      id="LicensingImage3"
                                                      alt="Document 3"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  )}
                                                  <input
                                                    type="file"
                                                    id="Doc3"
                                                    className="form-control"
                                                    name="Doc3"
                                                    accept=".jpg, .jpeg, .png, .pdf, .webp"
                                                    onChange={(event) => {
                                                      const file = event.target.files[0];
                                                      if (file) {
                                                        const reader = new FileReader();
                                                        reader.onload = (e) => {
                                                          const imgElement = document.getElementById("LicensingImage3");
                                                          if (imgElement) {
                                                            var computedStyle = window.getComputedStyle(imgElement);
                                                            var allStyles = "";
                                                            for (var i = 0; i < computedStyle.length; i++) {
                                                              var styleProperty = computedStyle[i];
                                                              allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                                            }
                      
                                                            var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                                            iframe.src = e.target.result;
                                                            iframe.style.cssText = allStyles;
                                                            iframe.style.border = "none";
                                                            iframe.id = imgElement.id;
                                                            imgElement.parentNode.replaceChild(iframe, imgElement);
                                                          }
                                                        };
                                                        reader.readAsDataURL(file);
                                                        setInputs((prevData) => ({ ...prevData, Doc3: file }));
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </div>
                      
                      


                        <div className="mb-4 col-12">
                          <label className="form-label text-dark" htmlFor="email">
                            About
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <ReactQuill
                            value={inputs.about}
                            onChange={handleDescriptionChange}
                            modules={{
                              toolbar: [
                                [
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                              ],
                            }}
                            formats={[
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                            ]}
                            bounds={".app"}
                          />
                        </div>



                            <div className="col-md-12">
                              <button
                                onClick={addGalleryImageDiv}
                                className="btn btn-secondary btn-sm"
                                type="button"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mx-1"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#1f2937"
                                  stroke-width="1.5"
                                  stroke-linecap="square"
                                  stroke-linejoin="arcs"
                                >
                                  <rect
                                    x="3"
                                    y="3"
                                    width="18"
                                    height="18"
                                    rx="2"
                                  />
                                  <circle cx="8.5" cy="8.5" r="1.5" />
                                  <path d="M20.4 14.5L16 10 4 20" />
                                </svg>
                                Add Gallery ( 1000px X 1000px )
                              </button>
                              <div id="imageContainerGallery" className="row mt-3">
                               
                                    {inputs.gallery.map((image, index) => (
                                      <div
                                        className="col-md-3 col-6"
                                        key={index}
                                      >
                                        <div
                                          className={`input-group imageupload-bx mb-3`}
                                        >
                                          <img
                                            className="image-preview"
                                            src={image}
                                            alt="Preview"
                                            id={`imageGalleryinputN${index + 1}`}
                                            data-bs-toggle="modal"
                                            data-bs-target="#modal-default"
                                          />
                                          <input
                                            type="hidden"
                                            className="form-control imageopen"
                                            id={`imageGalleryproductN${index + 1}`}
                                            name="productGalleryImg[]"
                                            value={image}
                                          />
                                        </div>
                                        <button
                                          className="btn btn-danger d-block m-auto"
                                          onClick={removeImageDiv}
                                        >
                                          Delete
                                        </button>
                                        <br />
                                      </div>
                                    ))}
                                 

                                {imageGalleryDivs.map((imageDiv, index) => (
                                  <React.Fragment key={index}>
                                    {imageDiv}
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
<hr/>


                            <div className="col-md-12">
                              <button
                                onClick={addImageDiv}
                                className="btn btn-secondary btn-sm"
                                type="button"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mx-1"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#1f2937"
                                  stroke-width="1.5"
                                  stroke-linecap="square"
                                  stroke-linejoin="arcs"
                                >
                                  <rect
                                    x="3"
                                    y="3"
                                    width="18"
                                    height="18"
                                    rx="2"
                                  />
                                  <circle cx="8.5" cy="8.5" r="1.5" />
                                  <path d="M20.4 14.5L16 10 4 20" />
                                </svg>
                                Add Images ( 1000px X 1000px )
                              </button>
                              <div id="imageContainer" className="row mt-3">
                               
                                    {inputs.images.map((image, index) => (
                                      <div
                                        className="col-md-3 col-6"
                                        key={index}
                                      >
                                        <div
                                          className={`input-group imageupload-bx mb-3`}
                                        >
                                          <img
                                            className="image-preview"
                                            src={image}
                                            alt="Preview"
                                            id={`imageinputN${index + 1}`}
                                            data-bs-toggle="modal"
                                            data-bs-target="#modal-default"
                                          />
                                          <input
                                            type="hidden"
                                            className="form-control imageopen"
                                            id={`imageproductN${index + 1}`}
                                            name="productImg[]"
                                            value={image}
                                          />
                                        </div>
                                        <button
                                          className="btn btn-danger d-block m-auto"
                                          onClick={removeImageDiv}
                                        >
                                          Delete
                                        </button>
                                        <br />
                                      </div>
                                    ))}
                                 

                                {imageDivs.map((imageDiv, index) => (
                                  <React.Fragment key={index}>
                                    {imageDiv}
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>


                      </div>
                    </div>

                     <div className="col-lg-4">
                                              <Gallery />
                                            </div>

                    <div className="col-md-12 text-start">
                      {SubmitLoading ? (
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={handleSubmit}
                           
                        >
                        Create Account 
                        </button>
                      ) : (
                        <button
                          disabled
                          className="btn btn-primary"
                          type="button"
                        >
                          <span className="ms-1">Loading...</span>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                      )}
                    </div>
                  </form>
                }





              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AccountCreate;
